import React from 'react';
import './PayButton.css';

const PayButton = ({ onPay }) => {
  return (
    <button className="pay-button" onClick={onPay}>
      Next
    </button>
  );
};

export default PayButton;
